const SESSION_TYPE = {
  ONLINE: 'online',
  WEBINAR: 'webinar',
  CLASSROOM: 'classroom',
};

const SESSION_TYPES = Object.values(SESSION_TYPE);

const PURCHASE_STATUS = {
  FREE: 'free',
  PAID: 'paid',
};

const PURCHASE_STATUSES = Object.values(PURCHASE_STATUS);

/**
 * Checks if the logged user has access to the admin/creator
 * content, so, only the session owner/host/trainer should see the contentn
 *
 * @param session - Session Object
 * @param loggedUserId - Logged User ID
 * @returns {boolean} - has access or not (true/false)
 */
const checkIfHasCreatorAccess = (session, loggedUserId) =>
  loggedUserId === session?.owner ||
  loggedUserId === session?.trainer?._id ||
  loggedUserId === session?.host?._id;

/**
 * Check in the participation list if the user already subscribed or accepted invitation to join session
 * @param session - Session Object
 * @param loggedUserId - Logged User ID
 * @returns {unknown} - Found or not found, object or null
 */
const checkIfUserIsInParticipantsList = (session, loggedUserId) => session?.participants?.find(u => u === loggedUserId);

/**
 * Check if session contains courses
 * @param session - Session Object
 * @returns {boolean}
 */
const checkIfSessionHasCourses = session => session.courses && session.courses.length > 0;

/**
 * Checks if the user is the session trainer
 * @param session - Session Object
 * @param loggedUserId - Logged User ID
 * @returns {boolean}
 */
const checkIfIsTrainer = (session, loggedUserId) => loggedUserId === session?.trainer?._id;

export {
  SESSION_TYPES,
  SESSION_TYPE,
  PURCHASE_STATUS,
  PURCHASE_STATUSES,
  checkIfHasCreatorAccess,
  checkIfUserIsInParticipantsList,
  checkIfSessionHasCourses,
  checkIfIsTrainer,
};
